import i from "./memoize.js";
var o = i, t = 500;
function c(a) {
  var e = o(a, function(m) {
    return r.size === t && r.clear(), m;
  }), r = e.cache;
  return e;
}
var p = c;
export {
  p as default
};
//# sourceMappingURL=_memoizeCapped.js.map
